







































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { EStep, Steps } from '@/models/onboarding';

import { Typography } from '@/components/atoms';
import CheckIcon from '@/components/icons/Check.vue';

type StepInfo = {
  main: EStep;
  internal: number;
  currentIndex: number;
};

@Component<StepsIndicator>({
  components: {
    Typography,
    CheckIcon
  }
})
export default class StepsIndicator extends Vue {
  @Prop() readonly steps!: Steps;
  @Prop() readonly stepInfo!: StepInfo;
  @Prop({ default: false }) readonly showNumberWhenDone?: boolean;

  get stepsAmount() {
    return this.formatedSteps.length;
  }

  get formatedSteps() {
    const formatedSteps = Object.entries(this.steps).map(
      ([stepKey, stepData], index) => ({
        count: index + 1,
        value: stepKey,
        label: stepData.label,
        componentsAmount: stepData.components.length
      })
    );

    return formatedSteps;
  }

  isChecked(stepCount: number) {
    return this.stepInfo.main > stepCount;
  }

  stepProgressPercent(componentsAmount: number, stepCount: number) {
    if (stepCount > this.stepInfo.main) {
      return '0%';
    }

    if (stepCount < this.stepInfo.main) {
      return '100%';
    }

    const percent = (this.stepInfo.internal * 100) / componentsAmount;

    return `${percent}%`;
  }

  isActive(step: number) {
    return this.stepInfo.main === step;
  }
}
